export const OHL = {
    name: 'DV 425 TS OBRENOVAC - TENT A ( od G-6)',
    voltage: '400',
    regionCode: 'BGD',
    stanice: [{name: 'OBRENOVAC', position: {lat: 44.6651, lng: 20.1688}}],
    stubovi: [
        { index: 1, name: 'P-03', lat: 44.6642 , lng: 20.1669, sys: 1, portal: true  },
        { index: 2, name: '1', lat: 44.6644 , lng: 20.166, sys: 1 },
        { index: 3, name: '2', lat: 44.6672 , lng: 20.1652, sys: 1 },
        { index: 4, name: '3', lat: 44.6694 , lng: 20.1616, sys: 1 },
        { index: 5, name: 'P-099', lat: 44.6697 , lng: 20.1602, sys: 1, portal: true  }
    ],
    rasponi: [
        { name: 'P-03 - 1', position: [{ lat: 44.6642 , lng: 20.1669 }, { lat: 44.6644 , lng: 20.166 }] },
        { name: '1 - 2', position: [{ lat: 44.6644 , lng: 20.166 }, { lat: 44.6672 , lng: 20.1652 }] },
        { name: '2 - 3', position: [{ lat: 44.6672 , lng: 20.1652 }, { lat: 44.6694 , lng: 20.1616 }] },
        { name: '3 - P-099', position: [{ lat: 44.6694 , lng: 20.1616 }, { lat: 44.6697 , lng: 20.1602 }] }
    ]
}
